<template>
  <div>
    <div>
      {{ column_key }}
    </div>
    <v-btn @click="save" color="color1" class="white--text" :loading="saving">
      Save
    </v-btn>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-row class="pa-3 border-b--thin font-weight-medium align-center">
            Columns
            <v-spacer></v-spacer>
            
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-settings</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                @click="restoreDefaults">
                  <v-list-item-title>Restore defaults</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

          </v-row>
          <div v-if="duplicateKeys.length" class="caption pa-2 pink--text">
            Error: You have duplicate column names:
            <div class="font-weight-medium">
              {{ duplicateKeys }}
            </div>
            Column names must be unique
          </div>
          <column-card :items="items" @onItemSelected="onItemSelected"></column-card>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card>
          <edit-card v-if="item" :item="item"></edit-card>
          <div v-else>
            Select a column
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="caption">
      <v-col md="6">
        <json-viewer :item="items"></json-viewer>
      </v-col>
      <v-col md="6">
        <json-viewer :item="schemas"></json-viewer>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import ColumnCard from './components/column/ColumnCard'
import EditCard from './components/edit/EditCard'
import { SETTINGS as STATIC_SETTINGS } from '@/js/shared/static-strings.js'
import { TABLE_COLUMNS } from '@/js/shared/table-columns.js'

export default {
  props: {
    column_key: '',
  },

  components: {
    ColumnCard,
    EditCard
  },
  data () {
    return {
      items: [],
      item: null, // Set this to the selected item
      saving: false
    }
  },
  computed: {
    editableSchemas () {
      return this.items.filter(item => item.editable)
    },
    schemas () {
      // var editable = this.items.filter(item => item.editable)
      var schemas = this.items.reduce((a, i) => {
        a[i.name] = i._schema
        return a
      }, {})
      return schemas
    },
    duplicateKeys () {
      var nameArray = this.editableSchemas.map(item => item.name)
      let result = Array.from(new Set(nameArray.filter((v, i, a) => a.indexOf(v) !== i)))
      return result
    }
  },
  methods: {
    onItemSelected (item) {
      this.item = item
    },
    restoreDefaults () {
      this.items = JSON.parse(JSON.stringify(TABLE_COLUMNS[this.column_key]))
    },
    loadAPI () {
      let schema = JSON.parse(this.$store.state.settings.dict[this.column_key]) || {}
      this.items = schema
    },
    save () {
      return new Promise((resolve, reject) => {
        let data = {
          column_schema: this.column_key,
          value: this.items
        }
        this.saving = true
        this.$axios.patch(`settings/update-column-schema`,
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            setTimeout(() => {
              this.loadAPI()
            }, 500)
            resolve()
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            setTimeout(() => {
            this.saving = false
            }, 200)
          })
      })
    }
  },
  created () {
    this.loadAPI()
  }
}
</script>